import { createElement } from 'react';
import {
  createFrontendPlugin,
  ExtensionDefinition,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint, EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { rootRouteRef } from './routes';
import { Entity } from '@backstage/catalog-model/alpha';

// we dont need a simple card, we want a tab with some content, 
// so we can use the EntityContentBlueprint to create a tab for the user entity that will host the card. The card itself can be created using the EntityCardBlueprint, 
// which will be used inside the content tab.
//
// const userProjectHistoryCard = EntityCardBlueprint.make({
//   name: 'user-project-history',  
//   params: {
//     filter: entity => entity.kind === 'User',
//     loader: async () => {
//       const { UserProjectHistoryComponent } = await import('./components/ProjectHistory/ProjectHistoryCard');
//       return createElement(UserProjectHistoryComponent);
//     },
//   },
// });

// 2. Entity content (tab) that hosts the card
const userProjectHistoryContent = EntityContentBlueprint.make({
  name: 'user-project-history',
  params: {
    path: 'history',
    title: 'Project History',
    icon: 'history',   // optional, or a ReactElement
    loader: async () => {
      const { UserProjectHistoryComponent } = await import(
        './components/ProjectHistory/ProjectHistoryCard'
      );
      return createElement(UserProjectHistoryComponent);
    },
    // only for User entities
    filter: (entity: Entity) => entity.kind === 'User',
  },
});

const projectHistoryCard = EntityCardBlueprint.make({
  name: 'project-history',  
  params: {
    filter: entity => entity.kind === 'ProjectsHistory',
    loader: async () => {
      const { ProjectHistoryComponent } = await import('./components/ProjectHistory/ProjectHistoryCard');
      return createElement(ProjectHistoryComponent);
    },
  },
});

const extensions: ExtensionDefinition[] = [
  userProjectHistoryContent as ExtensionDefinition,
  projectHistoryCard as ExtensionDefinition,
];

export const projectHistoryPlugin = createFrontendPlugin({
  pluginId: 'project-history',
  routes: {
    root: rootRouteRef,
  },
  extensions,
});

export default projectHistoryPlugin;
